import styled, { css } from 'styled-components';

import type { ThemeSpaceType } from 'src/styles/theme';

import LinkWithQuery from '../LinkWithQuery';

export const Container = styled.div<{
  isAlignedRight?: boolean;
  marginBottom?: ThemeSpaceType;
  marginRight: string;
}>`
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.small};
  line-height: 1.7;
  width: 100%;
  position: relative;
  margin-bottom: ${props => (props.marginBottom ? props.theme.space[props.marginBottom] : 'initial')};

  ${props => props.theme.mediaQueries.medium} {
    width: fit-content;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    ${props =>
      props.isAlignedRight &&
      css`
        margin-left: auto;
        margin-right: ${(props: any) => props.marginRight};
      `}
  }
`;

export const CopyrightText = styled.div<{ textColor: string }>`
  color: ${props =>
    props.textColor === 'white'
      ? props.theme.colors.white
      : props.textColor === 'gray'
      ? props.theme.colors.capsuleGray50
      : 'inherit'};
`;

export const FooterLink = styled(props => <LinkWithQuery {...props} />)`
  color: ${props => props.theme.colors.capsuleGreen50};
  display: inline-block;

  &:first-of-type:before,
  &:not(:last-of-type):after {
    content: '\\007C';
    color: ${props => props.theme.colors.capsuleGray50};
    margin: 0 0.6rem;
    display: inline-block;
  }

  ${props => props.theme.mediaQueries.mediumDown} {
    &:first-of-type:before {
      content: none;
    }
  }
`;

export const StyledAnchorTag = styled.a`
  color: ${props => props.theme.colors.capsuleGreen50};
  display: inline-block;

  &:first-of-type:before,
  &:not(:last-of-type):after {
    content: '\\007C';
    color: ${props => props.theme.colors.capsuleGray50};
    margin: 0 0.6rem;
    display: inline-block;
  }

  ${props => props.theme.mediaQueries.mediumDown} {
    &:first-of-type:before {
      content: none;
    }
  }
`;
